
import _ from "lodash"
import FloorWrapper from "./FloorWrapper"
import Navigate from "./controls/components/Navigate"
import WareRcmd from "./controls/components/WareRcmd"
import ImageArea from "./controls/components/ImageArea"
import RichText from "./controls/components/RichText"

export default {
  name: "DshopRender",
  components: {
    FloorWrapper,
    Navigate,
    WareRcmd,
    ImageArea,
    RichText
  },
  props: {
    renderData: {
      type: Object,
      required: true
    }
  },
  computed: {
    moduleList() {
      return this.renderData?.moduleList || []
    }
  },
  mounted() {
    this.debouncedScrollHandler = _.debounce(() => {
      this.handleScroll()
    }, 200)

    //  主动执行一次
    this.debouncedScrollHandler()
    window.addEventListener("scroll", this.debouncedScrollHandler)
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.debouncedScrollHandler)
  },
  methods: {
    handleScroll() {
      const windowHeight = window.innerHeight
      const scrollTop = window.scrollY

      // 遍历楼层，判断商品楼层是否可见
      this.moduleList.forEach(floor => {
        const floorElement = document.getElementById(`anchor-${floor.instanceId}`)

        if (!floorElement) return

        const { type } = floorElement.dataset

        if (type !== "ware-rcmd") {
          return
        }

        const floorTop = floorElement.offsetTop
        const floorHeight = floorElement.offsetHeight

        const isFloorVisible =
          (floorTop >= scrollTop && floorTop < scrollTop + windowHeight) ||
          (floorTop + floorHeight > scrollTop && floorTop + floorHeight <= scrollTop + windowHeight) ||
          (floorTop < scrollTop && floorTop + floorHeight >= scrollTop + windowHeight)

        if (isFloorVisible && !floor.__updated__) {
          floor.__updated__ = isFloorVisible
          // 匹配商品楼层，调用价签接口查询商品价格、促销标签等信息
          const floorComponent = this.$refs.floorRef.find(ref => ref.$attrs["instance-id"] === floor.instanceId)
          if (floorComponent) {
            floorComponent.$children[0].getWareDetailData()
          }
        }
      })
    }
  }
}
